<template>
    <div class="hire">
        <Nav />
        <div class="pt-5 mt-5"></div>
        <div class="mt-5 px-2">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

import Nav from '@/components/Nav.vue'

export default {
    name: 'hire',
    components: {
        Nav
    },
    computed: {
        isLoggedIn: () => {
          return this.$store.getters.isLoggedIn;
        }
    },
    methods: {
        
    }
}
</script>

<style scoped>
p,li,span{
    font-size: 12px;
}

</style>